import { SortEnum, TeamsV2Query, TeamsV2QueryVariables } from '@/types/generated/graphql';
import { useState } from 'react';
import { useCursorPagination } from '@shared/hooks/use-cursor-pagination';
import { CURSOR_TEAMS_V2 } from '@/graphql/cursor.graphql';
import { SelectTeamTypeEnum } from '../teams.types';

export function useTeams() {
  const [filter, setFilter] = useState({
    query: '',
    order: '',
    sort: SortEnum.DESC,
    limit: 20,
  });
  const { data, initialLoading, hasNextPage, loadNextRef, loading } = useCursorPagination<
    TeamsV2Query,
    TeamsV2QueryVariables
  >({
    schema: CURSOR_TEAMS_V2,
    responseDataKey: 'teamsV2',
    variables: filter,
  });
  function handleSortTeam(order: string) {
    setFilter((prev) => ({
      ...prev,
      order: order,
      sort: order === SelectTeamTypeEnum.name ? SortEnum.ASC : SortEnum.DESC,
    }));
  }
  return {
    data,
    setFilter,
    filter,
    loading,
    loadNextRef,
    hasNextPage,
    initialLoading,
    handleSortTeam,
  };
}
